import type { DataById } from 'state/formData';
import type { WorkspaceType } from 'state/workspaces/model';
import type { BaseWorkspaceTabContent } from 'state/workspaces/tabContent/tabContent.model';

export type UpdateFieldActionById = Record<string, 'add' | 'replace'>;

export interface BatchTabContentFormDetails {
  negotiationId: string;
  quoteId?: string;
  pricerRfqId?: string;
}

export type BatchWorkspaceTabContent = BaseWorkspaceTabContent & {
  workspace: WorkspaceType;
  formIds: readonly string[];
  forms: readonly BatchTabContentFormDetails[];
  productSubtype?: string;
  productType?: string;
  wrapper?: string;
  payoffType?: string;
  isProductValidated: boolean;
  isMultipleApplyOpened: boolean;
  selectedFieldsIds: readonly string[];
  fields: DataById;
  updateActions: UpdateFieldActionById;
  isDeleteFormConfirmationModalOpen: boolean;
};

export type BatchWorkspaceTabContentState = Record<string, Readonly<BatchWorkspaceTabContent>>;

export const initialBatchWorkspaceTabContentState: BatchWorkspaceTabContentState = {};
